import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { trackBlogView } from "../../services/blogApi";

const Tag = styled.p`
  color: #ffffff !important;
  margin: 0;
  padding: 6px 12px;
`;

export default function BlogBox({ img, tag, title, text, author, slug }) {
  const handleViewClick = () => {
    // Track the view when user clicks "View Article" button
    if (slug) {
      trackBlogView(slug);
    }
  };

  return (
    <Wrapper className="radius8 shadow">
      {img && (
        <ImageWrapper>
          <img src={img} alt={title} />
        </ImageWrapper>
      )}
      <ContentWrapper>
        <h3 className="font20 extraBold">{title}</h3>
        <p className="font13" style={{ padding: "20px 0" }}>
          {text}
        </p>
        <AuthorInfo className="font13 extraBold">{author}</AuthorInfo>
        <div className="flex" style={{ justifyContent: "space-between", alignItems: "center" }}>
          <Tag className="tag purpleBg radius6 font13 extraBold whiteColor">{tag}</Tag>
          <ViewButton to={`/blog/${slug}`} onClick={handleViewClick} className="font13 semiBold">
            View Article
          </ViewButton>
        </div>
      </ContentWrapper>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100%;
  text-align: left;
  margin-top: 30px;
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  color: #000000;
  background: #ffffff;
  
  h3 {
    color: #4b2e83;
  }
  
  p {
    color: #000000;
  }
  
  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 12px 40px rgba(75, 46, 131, 0.15);
  }
`;

const ImageWrapper = styled.div`
  width: 100%;
  height: 200px;
  overflow: hidden;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }
  
  ${Wrapper}:hover & img {
    transform: scale(1.05);
  }
`;

const ContentWrapper = styled.div`
  padding: 20px 30px;
`;

const AuthorInfo = styled.p`
  color: #000000;
  margin-bottom: 15px;
`;

const ViewButton = styled(Link)`
  background: #f8f8ff;
  color: #4b2e83;
  padding: 8px 16px;
  border-radius: 20px;
  text-decoration: none;
  transition: all 0.3s ease;
  font-size: 0.8rem;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(75, 46, 131, 0.3);
    text-decoration: none;
    color: #4b2e83;
    background: #f0f0f0;
  }
`;
